import { Card, debounce, InputBase, Paper, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import * as React from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import { useSelector } from 'react-redux';
import { getDetailsDescription, getSubmissionDetails } from 'application/redux/selectors';
import { useActions } from 'hooks/useActions';
import * as Actions from 'application/redux/actions';
import { useCallback, useEffect, useRef, useState } from 'react';
import { updateSubmissionDescription } from 'services/submission';
import styles from '../Styles/styles';

interface Props {
    inForce?: boolean;
}

const ProjectDescription: React.FunctionComponent<Props & WithStyles<typeof styles>> = (props) => {
    const { inForce, classes } = props;

    const submission = useSelector(getSubmissionDetails);
    const description = useSelector(getDetailsDescription);
    const { saveSubmissionDescription } = useActions(Actions);
    const [curDescription, setCurDescription] = useState<string>(description);
    const [showSaving, setShowSaving] = useState<boolean>(false);
    const showSavingDescTimeout = useRef<any>(null);

    useEffect(() => {
        setCurDescription(description);
    }, [description]);

    const handleSaveDescription = async (newDescription: string) => {
        if (newDescription === description) return; // we have already saved this
        setShowSaving(true);
        await updateSubmissionDescription(submission.id, newDescription);
        saveSubmissionDescription(newDescription);
        try {
            clearTimeout(showSavingDescTimeout.current);
            showSavingDescTimeout.current = null;
        } catch (e) {
            // do nothing if we can't clear, must not be active
        }
        showSavingDescTimeout.current = setTimeout(() => {
            setShowSaving(false);
            showSavingDescTimeout.current = null;
        }, 2000);
    };

    const debounced = useCallback(debounce(handleSaveDescription, 10000), [description]);

    return (
        <Card>
            <Grid
                container
                className={classes.root}
                direction="column"
                justifyContent="center"
                alignItems="stretch"
                spacing={0}
            >
                <Grid style={{ marginTop: '0' }}>
                    <Typography variant="h4">Project Description</Typography>
                </Grid>
                <Grid className={classes.notesGridItem}>
                    <Paper className={classes.paperNotes}>
                        <InputBase
                            readOnly={inForce}
                            multiline
                            margin="none"
                            value={curDescription}
                            placeholder={'Description of project'}
                            classes={{ root: classes.notesTextField, input: classes.narrative }}
                            onChange={(event) => {
                                setCurDescription(event.target.value);
                                // TODO save notes to submission via API call
                                debounced(event.target.value);
                            }}
                            onBlur={(event) => {
                                handleSaveDescription(event.target.value);
                                debounced.clear();
                            }}
                        />
                        {showSaving && (
                            <Typography className={classes.saving} variant={'subtitle1'}>
                                saving...
                            </Typography>
                        )}
                    </Paper>
                </Grid>
            </Grid>
        </Card>
    );
};

export default withStyles(styles)(React.memo(ProjectDescription));
